import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import { testimonials, faqItems } from '@/mocks/data';
import { OrganizationSchema, WebSiteSchema, WebPageSchema, BreadcrumbListSchema, FAQPageSchema } from '@/components/base/SchemaOrg';

export default function AboutPage() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        pageUrl="http://921xwm.cn/about"
        pageName="关于51爆料网 - 品牌介绍与联系方式"
        description="51爆料网每日爆料黑料吃瓜，品牌介绍、平台声誉、联系方式，独家八卦免费回顾。了解51爆料网的品牌理念与平台实力。"
      />
      <BreadcrumbListSchema
        items={[
          { name: '首页', url: 'http://921xwm.cn/' },
          { name: '关于我们', url: 'http://921xwm.cn/about' },
        ]}
      />
      <FAQPageSchema faqs={faqItems} />

      <Header />

      <main>
        {/* Hero */}
        <section className="relative w-full min-h-[380px] md:min-h-[440px] flex items-center overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20abstract%20brand%20concept%20with%20elegant%20geometric%20shapes%2C%20subtle%20red%20glow%2C%20minimalist%20corporate%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20luxury%20noir%20aesthetic%2C%20sophisticated%20composition&width=1920&height=800&seq=about-hero-2026&orientation=landscape"
              alt="关于51爆料网"
              className="w-full h-full object-cover object-top"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50" />
          </div>

          <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
            <div className="max-w-4xl mx-auto text-center">
              <nav aria-label="面包屑导航" className="mb-4">
                <ol className="flex items-center justify-center gap-2 text-sm text-foreground-400">
                  <li><Link to="/" className="hover:text-primary-400 transition-colors">首页</Link></li>
                  <li><span className="text-foreground-600">/</span></li>
                  <li><span className="text-primary-400">关于我们</span></li>
                </ol>
              </nav>

              <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-50 mb-4">
                关于<span className="text-primary-400">51爆料网</span>
              </h1>
              <p className="text-foreground-400 text-base md:text-lg max-w-2xl mx-auto">
                51爆料网是领先的中文娱乐八卦资讯平台，致力于为"吃瓜群众"提供最新、最全、最真实的娱乐爆料内容。每日更新黑料吃瓜，做最懂你的吃瓜社区。
              </p>
            </div>
          </div>
        </section>

        {/* Brand Philosophy - About Style */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block px-4 py-1.5 bg-primary-500/10 border border-primary-500/30 text-primary-400 text-xs font-medium rounded-full mb-6 whitespace-nowrap">
              品牌信誉
            </span>

            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-50 leading-tight mb-6">
              我们坚信
              <br />
              <span className="text-foreground-400">吃瓜也是一种态度</span>
            </h2>

            <p className="text-foreground-400 text-base leading-relaxed max-w-2xl mx-auto">
              在这个信息爆炸的时代，真实、深度、有态度的娱乐资讯比任何时候都更加珍贵。51爆料网坚持"不实锤不发"的原则，每条爆料都经过多渠道交叉验证，为吃瓜群众提供值得信赖的娱乐内容。
            </p>
          </div>
        </section>

        {/* Platform Stats - Feature Grid */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 text-center mb-12">
              平台实力
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {[
                { icon: 'ri-user-star-line', value: '1000万+', label: '月活吃瓜用户', desc: '覆盖全国核心吃瓜人群' },
                { icon: 'ri-article-line', value: '2万+', label: '累计爆料文章', desc: '涵盖娱乐圈各领域深度内容' },
                { icon: 'ri-fire-line', value: '50+', label: '日均更新爆料', desc: '7×24小时全天候追踪热点' },
                { icon: 'ri-shield-check-line', value: '98%', label: '内容真实率', desc: '多渠道交叉验证确保可靠性' },
              ].map((stat) => (
                <div key={stat.label} className="relative bg-background-200/70 rounded-lg p-6 text-center overflow-hidden group hover:bg-background-200 transition-colors duration-300">
                  <div className="absolute inset-0 opacity-[0.03]">
                    <img
                      src="https://readdy.ai/api/search-image?query=Dark%20abstract%20minimalist%20geometric%20pattern%2C%20subtle%20red%20lines%2C%20dark%20background%2C%20editorial%20style%2C%20high%20contrast%2C%20luxury%20noir%20aesthetic&width=400&height=400&seq=stat-bg-about&orientation=squarish"
                      alt=""
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="relative z-10">
                    <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-500/15 flex items-center justify-center">
                      <i className={`${stat.icon} text-primary-400 text-xl`} />
                    </div>
                    <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-1">
                      {stat.value}
                    </div>
                    <div className="text-foreground-300 font-medium text-sm mb-1">{stat.label}</div>
                    <div className="text-foreground-600 text-xs">{stat.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* User Testimonials */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 text-center mb-10">
              用户口碑
            </h2>

            <div className="relative bg-background-200/70 rounded-2xl p-8 md:p-12 overflow-hidden">
              <div className="absolute top-0 left-0 w-48 h-48 opacity-[0.03]">
                <i className="ri-chat-quote-line text-foreground-50 text-[150px]" />
              </div>

              <div className="relative space-y-8">
                {testimonials.map((t, i) => (
                  <div key={t.id} className={`flex flex-col sm:flex-row gap-4 ${i < testimonials.length - 1 ? 'pb-8 border-b border-background-300/30' : ''}`}>
                    <div className="w-12 h-12 rounded-xl bg-background-400 flex items-center justify-center shrink-0">
                      <span className="text-foreground-300 font-heading font-bold text-lg">{t.avatar}</span>
                    </div>
                    <div>
                      <i className="ri-double-quotes-l text-primary-500/50 text-lg mb-1 block" />
                      <p className="text-foreground-400 text-sm leading-relaxed italic">
                        {t.comment}
                      </p>
                      <p className="text-foreground-600 text-xs mt-3 not-italic">
                        &mdash; {t.name}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 text-center mb-10">
              常见问题
            </h2>

            <div className="space-y-3">
              {faqItems.map((faq) => (
                <details key={faq.question} className="group bg-background-200/70 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-200 transition-colors">
                    <h3 className="text-foreground-200 font-medium text-sm pr-4">{faq.question}</h3>
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform text-lg shrink-0" />
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-foreground-500 text-sm leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="bg-background-100 rounded-2xl overflow-hidden">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2 h-64 lg:h-auto overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20elegant%20communication%20concept%20with%20glowing%20envelope%20icon%2C%20subtle%20red%20accents%2C%20minimalist%20corporate%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20luxury%20noir%20aesthetic&width=900&height=700&seq=contact-cta-2026&orientation=landscape"
                    alt="联系我们 - 51爆料网"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>

                <div className="lg:w-1/2 flex items-center p-8 md:p-14">
                  <div className="w-full">
                    <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 leading-tight mb-4">
                      独家八卦
                      <span className="text-primary-400 italic">免费回顾</span>
                      <br />
                      投稿爆料
                      <span className="text-foreground-500">立即查看</span>
                    </h2>

                    <p className="text-foreground-500 text-sm leading-relaxed mb-8">
                      如果你有娱乐圈独家内幕、一手爆料线索，欢迎联系我们。我们承诺对所有爆料人信息严格保密，并根据线索价值提供相应的稿酬奖励。
                    </p>

                    <div className="space-y-4 mb-8">
                      <div className="flex items-center gap-3 text-foreground-400 text-sm">
                        <div className="w-9 h-9 rounded-full bg-primary-500/15 flex items-center justify-center shrink-0">
                          <i className="ri-mail-line text-primary-400" />
                        </div>
                        <span>hello@921xwm.cn</span>
                      </div>
                      <div className="flex items-center gap-3 text-foreground-400 text-sm">
                        <div className="w-9 h-9 rounded-full bg-primary-500/15 flex items-center justify-center shrink-0">
                          <i className="ri-phone-line text-primary-400" />
                        </div>
                        <span>400-888-5151</span>
                      </div>
                      <div className="flex items-center gap-3 text-foreground-400 text-sm">
                        <div className="w-9 h-9 rounded-full bg-primary-500/15 flex items-center justify-center shrink-0">
                          <i className="ri-map-pin-line text-primary-400" />
                        </div>
                        <span>中国 · 北京市朝阳区</span>
                      </div>
                    </div>

                    <Link
                      to="/"
                      className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-sm"
                    >
                      返回首页吃瓜 <i className="ri-arrow-right-line" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}